import { zero3 } from '@/domain/geometry/vector3';
import { makeDataState } from '@/util/dataState';
import type { CatstackPlaneId } from '@/domain/anatomy/catstackPlane';
import type { CatstacksData } from '@/api/catstacksData';
import type { Vector3 } from 'three';
import type { Url } from '@/domain/types';
import type { SideId } from '@/domain/anatomy/side';
import type { OverlayCatstacksState } from '@/views/dicoms/overlay/overlayCatstacksState';

export type CaseInfo = {
    caseId: number;
    caseUrl: Url;
    caseVersion: string;
    operativeSide: SideId;
};

export type OverlayState = {
    // View state
    catstacks: OverlayCatstacksState;
    catstackMode: CatstackPlaneId;

    // Loaded state
    case: CaseInfo | null;
    catstacksData: CatstacksData | null;
    sceneCentre: Vector3;
};

/**
 * Create the initial catstack-overlay state
 */
export function overlayState(): OverlayState & ReturnType<typeof makeDataState> {
    return {
        catstacks: {
            axial: { visible: true, min: 0, max: 0, sliceIndex: 0 },
            coronal: { visible: true, min: 0, max: 0, sliceIndex: 0 },
            sagittal: { visible: true, min: 0, max: 0, sliceIndex: 0 },
        },
        catstackMode: 'coronal',
        case: null,
        catstacksData: null,
        sceneCentre: zero3(),
        ...makeDataState(),
    };
}

export function resetCatstackOverlayState(state: OverlayState & ReturnType<typeof makeDataState>) {
    const initial = overlayState();
    Object.assign(state, initial);
}
